module.exports = __webpack_public_path__ + "static/media/lte6.91ada339.jpg";